import { render, staticRenderFns } from "./server_info.vue?vue&type=template&id=1fadd333&scoped=true&"
import script from "./server_info.vue?vue&type=script&lang=js&"
export * from "./server_info.vue?vue&type=script&lang=js&"
import style0 from "./server_info.vue?vue&type=style&index=0&id=1fadd333&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fadd333",
  null
  
)

export default component.exports